/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean } from './common-D-vggmh2.js';

const validateHasCloser = (component, value) => {
    watchBoolean(component, '_hasCloser', value);
};

export { validateHasCloser as v };
//# sourceMappingURL=has-closer-DoXfZcmn.js.map

//# sourceMappingURL=has-closer-DoXfZcmn.js.map